import DateTime from '../components/DateTime.js';

const state = {
  activeEmployees: [],
  email: null,
  business: null,
  hotel: null,
  businessToken: null,
  isTokenValid: true,
  now: new Date,
  lastFetchTime: 0,
  postLoginPath: '/',
  roomsHousekeeping: [],
};

const mutations = {
  ACTIVE_EMPLOYEES (state, activeEmployees) {
    state.activeEmployees = activeEmployees;
  },
  EMAIL (state, email) {
    state.email = email;
  },
  BUSINESS (state, business) {
    state.business = business;
  },
  HOTEL (state, hotel) {
    state.hotel = hotel;
  },
  BUSINESS_TOKEN (state, businessToken) {
    state.businessToken = businessToken;
  },
  IS_TOKEN_VALID (state, isTokenValid) {
    state.isTokenValid = isTokenValid;
  },
  UPDATE_TIME (state) {
    state.now = new Date;
  },
  LAST_FETCH_TIME (state, lastFetchTime) {
    state.lastFetchTime = lastFetchTime;
  },
  POST_LOGIN_PATH (state, postLoginPath) {
    state.postLoginPath = postLoginPath;
  },
  ROOMS_HOUSEKEEPING (state, roomsHousekeeping) {
    state.roomsHousekeeping = roomsHousekeeping;
  }
};

const actions = {
  setEmail: (context, payload) => context.commit('EMAIL', payload),
  setBusiness: (context, payload) => context.commit('BUSINESS', payload),
  setHotel: (context, payload) => context.commit('HOTEL', payload),
  setActiveEmployees: (context, payload) => context.commit('ACTIVE_EMPLOYEES', payload),
  setBusinessToken: (context, payload) => context.commit('BUSINESS_TOKEN', payload),
  setIsTokenValid: (context, payload) => context.commit('IS_TOKEN_VALID', payload),
  setRoomsHousekeeping: (context, payload) => context.commit('ROOMS_HOUSEKEEPING', payload),
  setPostLoginPath (context, payload) {
    if (!payload) {
      payload = '/me';
    }
    context.commit('POST_LOGIN_PATH', payload);
  },
  start (context) {
    setInterval(() => {
      context.commit('UPDATE_TIME');
      context.dispatch('fetchDashboardOnInterval');
    }, 1000 * 60 / 6);
  },
  setLastFetchTime (context, payload) {
    context.commit('LAST_FETCH_TIME', payload);
  },
  logout (context) {
    window.api.get('/logout')
      .then((response) => {
        if (response.data.success) {
          context.dispatch('setUser', null);
        }
        else {
          console.log(response);
        }
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
      });
  },
};

const getters = {
  date: state => {
    return DateTime.numericDateTime(state.now);
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
